<template>
  <UCarousel
    :items="images"
    :ui="{
      container: 'gap-4',
      indicators: {
        wrapper: 'absolute top-[330px] bottom-auto',
        active: 'bg-gray-400 dark:bg-gray-400 mix-blend-plus-darker',
        inactive: 'bg-gray-200 dark:bg-gray-200 mix-blend-plus-darker',
      }
    }"
    arrows
    :indicators="showGalleryIndicators"
  >
    <template #default="{ item }">
      <div class="grid grid-cols-1 gap-4 content-start" draggable="false">
        <div>
          <NuxtImg v-if="item.urlWithProtocol" class="object-cover ao__aside max-h-60 lg:max-h-80 custom-size" :src="item.urlWithProtocol" :alt="item.caption || ''" sizes="sm:100vw lg:680px" draggable="false" />
          <img v-else class="object-cover max-h-80" src="~/assets/images/dummy/dummy.jpg" alt="" draggable="false" width="800" height="450" />
        </div>
        <div
          class="text-center flex flex-wrap mx-auto max-w-64 sm:max-w-96"
          :class="{'mt-4': showGalleryIndicators}"
          draggable="false"
        >
          {{ item.caption }}
        </div>
      </div>
    </template>

    <template #next="{ onClick, disabled }">
      <button
        @click="onClick"
        class="next-btn hidden lg:block bg-black/30 p-2.5 pl-3 rounded-full absolute top-40 right-4 transform -translate-y-1/2"
        :class="{'lg:hidden': disabled}"
      >
        <svg class="w-6 h-6 fill-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M16,21 C15.744,21 15.488,20.902 15.293,20.707 L7.293,12.707 C6.902,12.316 6.902,11.684 7.293,11.293 L15.293,3.293 C15.684,2.902 16.316,2.902 16.707,3.293 C17.098,3.684 17.098,4.316 16.707,4.707 L9.414,12 L16.707,19.293 C17.098,19.684 17.098,20.316 16.707,20.707 C16.512,20.902 16.256,21 16,21" transform="matrix(-1 0 0 1 24 0)"/>
        </svg>
      </button>
    </template>

    <template #prev="{ onClick, disabled }">
      <button
        @click="onClick"
        class="prev-btn hidden lg:block bg-black/30 p-2.5 pr-3 rounded-full absolute top-40 left-4 transform -translate-y-1/2"
        :class="{'lg:hidden': disabled}"
      >
        <svg class="w-6 h-6 fill-white transform rotate-180" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M16,21 C15.744,21 15.488,20.902 15.293,20.707 L7.293,12.707 C6.902,12.316 6.902,11.684 7.293,11.293 L15.293,3.293 C15.684,2.902 16.316,2.902 16.707,3.293 C17.098,3.684 17.098,4.316 16.707,4.707 L9.414,12 L16.707,19.293 C17.098,19.684 17.098,20.316 16.707,20.707 C16.512,20.902 16.256,21 16,21" transform="matrix(-1 0 0 1 24 0)"/>
        </svg>
      </button>
    </template>
  </UCarousel>
</template>

<script setup lang="ts">
import {type PropType} from "vue";
import type AssetLocal from "~/libs/interfaces/AssetLocal";

const config = useRuntimeConfig()
const showGalleryIndicators: boolean = !!config.public.showGalleryIndicators

const {
  images
} = defineProps({
  images: {type: Array as PropType<AssetLocal[]>, required: false, default: []}
})


</script>

<style lang="postcss">
.carousel__track {
  @apply gap-2;
}
</style>
